import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import ContactDuaContent from "../pages/Contacts/contact-dua-content";
import ContactDuaJumbotron from "../pages/Contacts/contact-dua-jumbotron";

export default function ContactDua() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <ContactDuaJumbotron />
      <ContactDuaContent />
      <Footer />
    </>
  );
}
